export default "__VITE_ASSET__BWlmFyEK__"